import { createReducer } from '../reducerUtil'
import {
  SET_QUIZ_MODE,
  SET_GUESS_MODE,
  SET_GUESS_OPTIONS,
  SET_GUESS_OPTION_SELECTED,
  SET_GUESS_ANSWER,
  SET_GUESS_KEY,
  SET_GUESSER_NAME,
} from './constants'

const initialState = {
  quizMode: false,
  guessMode: 'guess', // 3 modes: guess | correct | wrong
  guessOptions: [], // choose answer dropdown list
  guessOptionSelected: '', // answer chosen
  guessAnswer: '', // final answer
  guessKey: '', // data key to guess: flag | logo | name
  guesserName: '',
}

export const setQuizMode = (state, payload) => {
  return {
    ...state,
    quizMode: payload.mode,
  }
}

export const setGuessMode = (state, payload) => {
  return {
    ...state,
    guessMode: payload.mode,
  }
}

export const setGuessOptions = (state, payload) => {
  return {
    ...state,
    guessOptions: payload.options,
  }
}

export const setGuessOptionSelected = (state, payload) => {
  return {
    ...state,
    guessOptionSelected: payload.option,
  }
}

export const setGuessAnswer = (state, payload) => {
  return {
    ...state,
    guessAnswer: payload.answer,
  }
}

export const setGuessKey = (state, payload) => {
  return {
    ...state,
    guessKey: payload.key,
  }
}

export const setGuesserName = (state, payload) => {
  return {
    ...state,
    guesserName: payload.name,
  }
}

export default createReducer(initialState, {
  [SET_QUIZ_MODE]: setQuizMode,
  [SET_GUESS_MODE]: setGuessMode,
  [SET_GUESS_OPTIONS]: setGuessOptions,
  [SET_GUESS_OPTION_SELECTED]: setGuessOptionSelected,
  [SET_GUESS_ANSWER]: setGuessAnswer,
  [SET_GUESS_KEY]: setGuessKey,
  [SET_GUESSER_NAME]: setGuesserName,
})
